import { Injectable, ModuleWithProviders, NgModule } from '@angular/core';
import {
  // HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
  HttpContext,
} from '@angular/common/http';

// import { provideHttpClient, withInterceptors } from '@angular/common/http';

// Dal client generato:
import { Configuration, ConfigurationParameters } from '@prowodo/angular-client';
import { WorkingDaysService, APIS } from '@prowodo/angular-client';
// import { APIS } from 'prowodo-angular-client/api/api';

// La tua service
import { BaseAuthenticatedService } from '@app/services/base-authenticated.service';

// Interceptor
import { AuthInterceptor } from './auth.interceptor';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ADD_BACKEND_AUTH } from './auth.tokens';

export function createConfig(params: ConfigurationParameters): Configuration {
  return new Configuration(params);
}

@Injectable()
export class ApiAuthenticatedService extends BaseAuthenticatedService {
  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient
  ) {
    super(auth, httpClient);
  }
}

export function authApiDefaultParamCtx() {
  const body: 'body' | 'response' | 'events' = 'body';
  const ctx = new HttpContext().set(ADD_BACKEND_AUTH, true);
  return [body, false, { context: ctx }];
}
//   params: {
//     observe?: 'body' | undefined;
//     reportProgress?: boolean | undefined;
//     options?: {
//       httpHeaderAccept?: 'application/json' | undefined;
//       context?: HttpContext | undefined;
//     };
//   } = {
//     observe: 'body',
//     reportProgress: false,
//     options: {
//       httpHeaderAccept: 'application/json',
//       context: new HttpContext().set(ADD_BACKEND_AUTH, true),
//     },
//   }
// ) {
//   const ctx = new HttpContext().set(ADD_BACKEND_AUTH, true);
//   return {
//     observe: 'body',
//     reportProgress: false,
//     options: params?.options
//       ? { ...params.options, context: ctx }
//       : { context: ctx },
//   };
// }

// imports: [provideHttpClient(withInterceptors([authInterceptorFn]))],
@NgModule({})
export class ApiModule {
  static forRoot(
    params: ConfigurationParameters
  ): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        // Config globale per il client generato (basePath ecc.)
        { provide: Configuration, useValue: createConfig(params) },

        // Servizi del client (NO providedIn root, come richiesto)
        ...APIS,
        WorkingDaysService,

        // La tua service di autenticazione (token + refresh)
        ApiAuthenticatedService,

        // Interceptor che applica gli header auth ad ogni richiesta
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
      ],
    };
  }

  static forChild(
    params?: ConfigurationParameters
  ): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        ...(params
          ? [{ provide: Configuration, useValue: createConfig(params) }]
          : []),
        ...APIS,
        // WorkingDaysService,
        ApiAuthenticatedService,
        // { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        // Se vuoi istanze/scoping diversi per feature, puoi re-providare anche qui l’interceptor
      ],
    };
  }
}
